import styled from "styled-components";
import colors from "theme/colors.module.scss";
import shadows from "theme/shadows.module.scss";
import spacing from "theme/spacing.module.scss";
import borders from "theme/borders.module.scss";
import { Button } from "antd";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;

  .main-logo {
    margin-bottom: ${spacing.spacing};
    min-width: 120px;
    min-height: 120px;
    max-width: 80%;
    max-height: 30vh;
    height: auto;
    width: auto;
    object-fit: contain;
  }

  svg {
    color: ${colors.primaryPurple500};
  }

    .ant-btn-loading-icon {
        svg {
            color: ${colors.primaryBackground}; 
        }
    }

  a {
    color: ${colors.primaryPurple500};
    font-weight: 400;
    text-decoration: underline;
    margin-bottom: ${spacing.spacingXL};
    width: fit-content;
  }

  button {
    &:last-of-type {
      margin-top: ${spacing.spacingXL};
    }
  }
`;

export const StyledButton = styled(Button)`
    border-radius: ${borders.borderRadiusSM};
    flex: 1;
    border: none;
`;

export const Form = styled.form`
    padding: ${spacing.spacingLG} ${spacing.spacing} ${spacing.spacingXL};
    border-top-left-radius: ${borders.borderRadiusXXL};
    border-top-right-radius: ${borders.borderRadiusXXL};
    background-color: ${colors.primaryBackground};
    width: 100%;
    box-shadow: ${shadows.secondaryShadow};
    position: relative;
    z-index: 1;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  z-index: 0;
`;
export const CircleImage = styled.div`
  position: absolute;
  width: 100%;
  height: 380px;
  top: calc(50vh - 380px / 2 + 122px);
  z-index: -1;

  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(214, 185, 251, 0.6) 0%,
    rgba(214, 185, 251, 0.4) 100%
  );
  filter: blur(38px);
`;
